var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInCallMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_1789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33399H11.5333C11.5333 7.83065 11.43 8.29065 11.2433 8.70065L12.0633 9.52065C12.4433 8.87065 12.6667 8.12732 12.6667 7.33399ZM9.99 7.44398C9.99 7.40732 10 7.37065 10 7.33399V3.33398C10 2.22732 9.10333 1.33398 8 1.33398C6.89667 1.33398 6 2.22732 6 3.33398V3.45732L9.99 7.44398ZM2.85 2.00065L2 2.85065L6.00667 6.85732V7.33732C6.00667 8.44065 6.89667 9.33732 8 9.33732C8.15 9.33732 8.29333 9.31732 8.43333 9.28732L9.54 10.394C9.06333 10.614 8.54 10.7373 8 10.7373C6.16 10.7373 4.46667 9.33732 4.46667 7.33732H3.33333C3.33333 9.61399 5.14667 11.494 7.33333 11.8173V14.0007H8.66667V11.814C9.27 11.724 9.84333 11.514 10.36 11.2107L13.15 14.0007L14 13.154L2.85 2.00065Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_1789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInCallMicOff);
export default __webpack_public_path__ + "static/media/in_call_mic_off.701ee7d03ebe2d511abdcbf7498298d9.svg";
export { ForwardRef as ReactComponent };